declare global {
  interface Window {
    fbq: (...args: unknown[]) => void
    _fbq: (...args: unknown[]) => void
  }
}

const PIXEL_ID = '1559656868440505'

export function initMetaPixel() {
  if (typeof window === 'undefined' || window.fbq) return

  const n: any = (window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })
  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  // Load fbevents.js
  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const firstScript = document.getElementsByTagName('script')[0]
  if (firstScript?.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript)
  } else {
    document.head.appendChild(script)
  }

  // Init pixel and fire PageView
  window.fbq('init', PIXEL_ID)
  window.fbq('track', 'PageView')

  // Add noscript fallback
  const noscript = document.createElement('noscript')
  const img = document.createElement('img')
  img.height = 1
  img.width = 1
  img.style.display = 'none'
  img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`
  noscript.appendChild(img)
  document.body.appendChild(noscript)
}

// Fire AddToCart - does NOT prevent navigation, fires pixel reliably before redirect
export function trackAddToCart() {
  // 1. Fire via fbq SDK if loaded
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'Erectile Diffusion Guide',
      content_type: 'product',
      value: 6.39,
      currency: 'USD',
    })
  }

  // 2. Fire via sendBeacon (reliable even during navigation)
  const beaconUrl = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=AddToCart&cd[content_name]=Erectile%20Diffusion%20Guide&cd[content_type]=product&cd[value]=6.39&cd[currency]=USD&noscript=1&t=${Date.now()}`

  if (navigator.sendBeacon) {
    navigator.sendBeacon(beaconUrl)
  } else {
    // 3. Fallback: image pixel
    const img = new Image(1, 1)
    img.src = beaconUrl
  }
}
